module.exports = __webpack_public_path__ + "img/woman.9acba651.svg";